import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AccionesDialog } from '@models/base/identificadores.model';

@Component({
  selector: 'app-dialog-nuevo-periodo-o-adenda',
  templateUrl: './dialog-nuevo-periodo-o-adenda.component.html',
  styleUrls: ['./dialog-nuevo-periodo-o-adenda.component.css']
})
export class DialogNuevoPeriodoOAdendaComponent implements OnInit {


  constructor(
    public dialogRef: MatDialogRef<DialogNuevoPeriodoOAdendaComponent>
  ) { }

  ngOnInit(): void {
  }

  closeDialog() {
    this.dialogRef.close({ event: AccionesDialog.Cancelar });
  }

  aceptaAdenda() {
    this.dialogRef.close({ event: AccionesDialog.Aceptar });
  }

  nuevosPeriodos() {
    this.dialogRef.close({ event: AccionesDialog.Agregar });
  }


}
